import moment from "moment";
import {connect} from "redux-vue";
import * as commentActions from "../actions/comment";
import LoadingIndicator from "./LoadingIndicator";

const Comment = {
  props: ['modelProp', 'module', 'comment', 'likeComment', 'unLikeComment', 'user', 'createComment'],

  data () {
    return {
      replyForm: false,
      commentReply: "",
    }
  },

  methods: {
    onPressLike () {
      this.likeComment(this.modelProp);
    },
    onPressUnLike () {
      this.unLikeComment(this.modelProp);
    },
    onPressReply () {
      this.replyForm = !this.replyForm;
    },
    handleReplySubmit (e) {
      e.preventDefault();
      const comment = this.commentReply;
      if (comment.length) {
        this.createComment(comment, this.module.id, this.user.model.id, this.modelProp.id);
      }
    }
  },

  watch: {
    comment (nextVal, val) {
      if (val.create && nextVal.createSuccess && nextVal.replyId === this.modelProp.id) {
        this.replyForm = false;
        this.commentReply = "";
      }
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render (h) {

    const replyButton = (
      <button class="text-blue-500 hover:underline focus:outline-none focus:shadow-outline" onClick={this.onPressReply} disabled={this.comment.create}>
        <i class="mdi mdi-reply mr-1"></i>
        {this.$t('course_page.reply')}
      </button>
    );

    const replyForm = this.replyForm && (
      <div class="flex">
        <div class="w-8 lg:w-10 h-8 lg:h-10 rounded-full overflow-hidden flex-shrink-0 bg-gray-300 relative mr-3 my-1 lg:my-0">
          <div class="absolute w-full h-full text-center">
            <i class="mdi mdi-account text-gray-800 text-xl leading-8 lg:leading-10"></i>
          </div>
          <div class="h-full w-full bg-center bg-cover z-10 relative"
               style={`background-image: url(${process.env.VUE_APP_BASE + "/" + this.user.model.avatar})`}></div>
        </div>
        <div class="flex-1">
          <div class="lg:py-2">
            <p>
              {this.user.model.name}
            </p>
          </div>
          <div class="mb-10">
            <form>
              <textarea
                class="bg-gray-200 text-sm appearance-none border border-faded-200 rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-3"
                placeholder={this.$t('course_page.reply_to_author', {author: this.modelProp.author.name})}
                rows="5" disabled={this.comment.create} vModel={this.commentReply}></textarea>
              <button
                class="flex-shrink-0 lg:mr-8 mb-3 lg:mb-0 p-2 px-5 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline"
                type="submit" onClick={this.handleReplySubmit} disabled={this.comment.create}>
                {this.comment.create && this.comment.replyId === this.modelProp.id && <LoadingIndicator />}
                {this.comment.create && this.comment.replyId === this.modelProp.id || (
                  <fragment>
                    {this.$t('course_page.share')}
                    <i class="mdi mdi-arrow-right ml-3"></i>
                  </fragment>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    );

    const likeDisabled = this.comment.model && this.comment.model.id === this.modelProp.id && this.comment.like;
    const likeButton = Boolean(this.modelProp.isLiked) || (
      <button type="button" class="text-blue-500 hover:underline focus:outline-none focus:shadow-outline" onClick={this.onPressLike} disabled={likeDisabled}>
        <i class="mdi mdi-thumb-up-outline mr-1"></i>
        {this.$t('course_page.like_this')}
      </button>
    );

    const unLikeDisabled = this.comment.model && this.comment.model.id === this.modelProp.id && this.comment.unLike;
    const unlikeButton = Boolean(this.modelProp.isLiked) && (
      <button type="button" class="text-blue-500 hover:underline focus:outline-none focus:shadow-outline font-bold" onClick={this.onPressUnLike} disabled={unLikeDisabled}>
        <i class="mdi mdi-thumb-up mr-1"></i>
        {this.$t('course_page.liked')}
      </button>
    );

    const replies = this.modelProp.all_replies || this.modelProp.replies;

    return (
      <div class="flex">
        <div
          class="w-8 lg:w-10 h-8 lg:h-10 rounded-full overflow-hidden flex-shrink-0 bg-gray-300 relative mr-3 my-1 lg:my-0">
          <div class="absolute w-full h-full text-center">
            <i class="mdi mdi-account text-gray-800 text-xl lg:leading-10"></i>
          </div>
          <div class="h-full w-full bg-center bg-cover z-10 relative"
               style={`background-image: url(${process.env.VUE_APP_BASE + "/" + this.modelProp.author.avatar})`}></div>
        </div>
        <div class="flex-1">
          <div class="border-b flex flex-col lg:flex-row lg:justify-between lg:py-2">
            <p>
              {this.modelProp.author.name}
            </p>
            <p>
              {moment(this.modelProp.created_at).format("H:mm on D MMM YYYY")}
            </p>
          </div>
          <p class="py-3">
            {this.modelProp.comment}
          </p>
          <ul class="flex flex-wrap items-center mb-10">
            <li class="mb-2 lg:mb-0 lg:mr-10 w-full lg:w-auto">
              {replyButton}
            </li>
            <li>
              {likeButton}
              {unlikeButton}
            </li>
            {this.modelProp.likeCount > 0 && (
              <li class="ml-auto">
                <i class="mdi mdi-thumb-up text-orange-600 mr-1"></i>
                {this.modelProp.likeCount}
              </li>
            )}
          </ul>

          <ul>
            <li>
              {replyForm}
            </li>
            {replies.map(i => (
              <li>
                <ConnectedComment modelProp={i} module={this.module} key={i.id}/>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    comments: state.comments,
    comment: state.comment,
  };
}

function mapActionToProps(dispatch) {
  return {
    likeComment: (id) => dispatch(commentActions.likeComment(id)),
    unLikeComment: (id) => dispatch(commentActions.unLikeComment(id)),
    createComment: (comment, link_id, user_id, reply_id) =>
      dispatch(commentActions.createComment(comment, link_id, user_id, reply_id)),
  }
}

const ConnectedComment = connect(mapStateToProps, mapActionToProps)(Comment);

export default ConnectedComment;
